__webpack_require__.p = "/Valorant-Infos/";